/* Spartan reels: in-view autoplay for reel cards + full-screen, story-style player with Add to cart.
   Markup: [data-sf-reels] containing [data-sf-reel-open="i"] cards and a JSON list in [data-sf-reels-data]. */
(() => {
  if (window.sfReelsReady) return;
  window.sfReelsReady = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  // ---- Cards: only the card most in view plays (muted, looping); the rest stay as posters ----
  function wireCards(root) {
    const vids = [...root.querySelectorAll('video[data-sf-card-video]')];
    // Posters past the first 7 load once their card is within about a row's width of the screen
    const lazy = vids.filter((v) => v.dataset.poster);
    const showPoster = (v) => { if (v.dataset.poster) { v.poster = v.dataset.poster; delete v.dataset.poster; } };
    if (lazy.length) {
      if ('IntersectionObserver' in window) {
        const track = root.querySelector('.sf-reels__track');
        const pio = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { showPoster(e.target); pio.unobserve(e.target); } }), { root: track, rootMargin: '0px 150% 0px 150%' });
        lazy.forEach((v) => pio.observe(v));
      } else lazy.forEach(showPoster);
    }
    if (!vids.length || reduce || !('IntersectionObserver' in window)) return;
    const seen = new Map();
    const first = root.querySelector('video[data-sf-first]');
    const pick = () => {
      // The first card wins while it is in view, so the row always opens on it playing
      let best = first && (seen.get(first) || 0) > 0.5 ? first : null; let ratio = best ? 1.01 : 0.6;
      seen.forEach((r, v) => { if (r > ratio) { ratio = r; best = v; } });
      vids.forEach((v) => {
        if (v === best) { if (!v.src) v.src = v.dataset.src; v.play().catch(() => {}); } else v.pause();
      });
      // Warm up the next card so it starts instantly when it takes over
      const nx = best && vids[vids.indexOf(best) + 1];
      if (nx && !nx.src) { showPoster(nx); nx.preload = 'metadata'; nx.src = nx.dataset.src; }
    };
    // A lighter copy that fails to load falls back to the full-size one
    vids.forEach((v) => v.addEventListener('error', () => {
      if (!v.dataset.full || v.getAttribute('src') === v.dataset.full) return;
      v.src = v.dataset.full; v.dataset.src = v.dataset.full; pick();
    }, true));
    const io = new IntersectionObserver((es) => { es.forEach((e) => seen.set(e.target, e.intersectionRatio)); pick(); }, { threshold: [0, 0.6, 0.8, 1] });
    vids.forEach((v) => io.observe(v));
  }

  // ---- Homepage row arrows: scroll by the visible width, hide at the ends ----
  function wireArrows(root) {
    const sec = root.closest('section') || root;
    const prev = sec.querySelector('[data-sf-reels-prev]'); const next = sec.querySelector('[data-sf-reels-next]');
    const track = root.querySelector('.sf-reels__track');
    if (!prev || !next || !track) return;
    const step = () => Math.max(track.clientWidth * 0.8, 200);
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }));
    const sync = () => {
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      root.classList.toggle('is-start', prev.disabled); root.classList.toggle('is-end', next.disabled);
    };
    track.addEventListener('scroll', sync, { passive: true }); window.addEventListener('resize', sync); sync();
  }

  // ---- Full-screen player ----
  let dlg; let list; let items = []; let muted = true; let io;
  function build() {
    dlg = document.createElement('div');
    dlg.className = 'sf-player';
    dlg.setAttribute('role', 'dialog');
    dlg.setAttribute('aria-modal', 'true');
    dlg.setAttribute('aria-label', 'Product videos');
    dlg.innerHTML = '<div class="sf-player__top"><button type="button" class="sf-player__btn" data-sf-mute aria-label="Turn sound on"></button><button type="button" class="sf-player__btn" data-sf-close aria-label="Close videos"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div><div class="sf-player__list" data-sf-list></div><div class="sf-player__nav"><button type="button" class="sf-player__btn" data-sf-prev aria-label="Previous video"><svg viewBox="0 0 24 24"><path d="M6 15l6-6 6 6"/></svg></button><span class="sf-player__count" data-sf-count aria-live="polite"></span><button type="button" class="sf-player__btn" data-sf-next aria-label="Next video"><svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg></button></div>';
    document.body.appendChild(dlg);
    list = dlg.querySelector('[data-sf-list]');
    dlg.querySelector('[data-sf-close]').addEventListener('click', close);
    dlg.querySelector('[data-sf-mute]').addEventListener('click', () => { muted = !muted; syncMute(); });
    const step = (d) => list.scrollBy({ top: d * list.clientHeight, behavior: reduce ? 'auto' : 'smooth' });
    dlg.querySelector('[data-sf-prev]').addEventListener('click', () => step(-1));
    dlg.querySelector('[data-sf-next]').addEventListener('click', () => step(1));
    dlg.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); list.scrollBy({ top: (e.key === 'ArrowDown' ? 1 : -1) * list.clientHeight, behavior: 'smooth' }); }
    });
    list.addEventListener('click', (e) => {
      const th = e.target.closest('[data-sf-thumb]');
      if (th) { const pan = th.closest('.sf-player__panel'); pan.querySelector('.sf-player__main').src = th.dataset.sfThumb; pan.querySelectorAll('[data-sf-thumb]').forEach((b) => b.classList.toggle('is-on', b === th)); return; }
      if (e.target.closest('[data-sf-add], a, .sf-player__panel')) return;
      if (e.target.closest('video')) { muted = !muted; syncMute(); }
    });
  }
  function syncMute() {
    list.querySelectorAll('video').forEach((v) => { v.muted = muted; });
    const b = dlg.querySelector('[data-sf-mute]');
    b.innerHTML = muted ? '<svg viewBox="0 0 24 24"><path d="M4 9h4l5-4v14l-5-4H4zM17 9l4 6M21 9l-4 6"/></svg>' : '<svg viewBox="0 0 24 24"><path d="M4 9h4l5-4v14l-5-4H4zM16 8a5 5 0 0 1 0 8M18.5 5.5a9 9 0 0 1 0 13"/></svg>';
    b.setAttribute('aria-label', muted ? 'Turn sound on' : 'Turn sound off');
  }
  function slide(r, i) {
    const p = r.product;
    const bar = p ? `<div class="sf-player__bar">
        ${p.img ? `<img src="${esc(p.img)}" alt="" width="48" height="48">` : ''}
        <a class="sf-player__info" href="${esc(p.url)}"><span>${esc(p.title)}</span><strong>${esc(p.price)}</strong></a>
        ${p.available ? `<button type="button" class="sf-player__add" data-sf-add="${esc(p.variant)}">Add to cart</button>` : `<a class="sf-player__add sf-player__add--ghost" href="${esc(p.url)}">View</a>`}
      </div>` : '';
    const imgs = p && p.imgs && p.imgs.length ? p.imgs : (p && p.img ? [p.img] : []);
    const panel = p ? `<aside class="sf-player__panel" aria-label="Product">
        ${imgs.length ? `<div class="sf-player__gal"><img class="sf-player__main" src="${esc(imgs[0])}" alt="${esc(p.title)}" loading="lazy">
          ${imgs.length > 1 ? `<div class="sf-player__thumbs">${imgs.map((u, k) => `<button type="button" class="sf-player__thumb${k === 0 ? ' is-on' : ''}" data-sf-thumb="${esc(u)}" aria-label="Photo ${k + 1}"><img src="${esc(u)}" alt="" loading="lazy"></button>`).join('')}</div>` : ''}
        </div>` : ''}
        ${p.vendor ? `<p class="sf-player__vendor">${esc(p.vendor)}</p>` : ''}
        <a class="sf-player__ptitle" href="${esc(p.url)}">${esc(p.title)}</a>
        <p class="sf-player__price"><strong>${esc(p.price)}</strong>${p.compare ? `<s>${esc(p.compare)}</s><span class="sf-player__save">Save ${esc(p.save)}</span>` : ''}</p>
        ${p.desc ? `<p class="sf-player__desc">${esc(p.desc)}</p>` : ''}
        <div class="sf-player__ctas">
          ${p.available ? `<button type="button" class="sf-player__add sf-player__add--lg" data-sf-add="${esc(p.variant)}">Add to cart</button>` : ''}
          <a class="sf-player__more" href="${esc(p.url)}">View details</a>
          <p class="sf-player__trust">Free pickup at 15 stores &middot; Financing available</p>
        </div>
      </aside>` : '';
    return `<section class="sf-player__slide" data-i="${i}">
      <div class="sf-player__media">
        <video playsinline loop muted preload="none" poster="${esc(r.poster)}" data-src="${esc(r.src)}"></video>
        ${r.caption ? `<p class="sf-player__cap">${esc(r.caption)}</p>` : ''}
      </div>
      ${bar}
      ${panel}
    </section>`;
  }
  async function add(btn) {
    btn.disabled = true; const t = btn.textContent; btn.textContent = 'Adding…';
    try {
      const res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.dataset.sfAdd), quantity: 1 }] }) });
      if (!res.ok) throw new Error((await res.json()).description || 'error');
      btn.textContent = 'Added ✓';
      setTimeout(() => {
        close();
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
      }, 500);
    } catch (e) {
      btn.textContent = 'Try again'; btn.disabled = false; setTimeout(() => { btn.textContent = t; }, 2500);
    }
  }
  // Full screen: the smallest MP4 copy that is sharp at the player's size on this screen (device pixels),
  // one step lighter when the visitor has Data Saver on. Falls back to the 720p "src".
  function bestSrc(r, el) {
    const list = (r.srcs || []).filter((s) => s.u && s.w && s.h).sort((a, b) => a.w * a.h - b.w * b.h);
    if (!list.length) return r.src;
    const box = el.getBoundingClientRect();
    const dpr = Math.min(window.devicePixelRatio || 1, 3);
    const needW = box.width * dpr * 0.9; const needH = box.height * dpr * 0.9;
    let i = list.findIndex((s) => s.w >= needW || s.h >= needH);
    if (i < 0) i = list.length - 1;
    if (navigator.connection && navigator.connection.saveData && i > 0) i -= 1;
    return list[i].u;
  }
  const loadSlide = (s) => {
    const sv = s && s.querySelector('video'); if (!sv || sv.src) return;
    const r = items[Number(s.dataset.i)] || {};
    sv.src = bestSrc(r, sv);
    // A lighter copy that fails to load falls back to the full-size one
    sv.addEventListener('error', () => { if (r.src && sv.getAttribute('src') !== r.src) { const was = !sv.paused; sv.src = r.src; if (was || sv.autoplay) sv.play().catch(() => {}); } }, { once: true });
  };

  let lastFocus;
  function open(data, start) {
    if (!dlg) build();
    items = data;
    lastFocus = document.activeElement;
    list.innerHTML = data.map(slide).join('');
    const cnt = dlg.querySelector('[data-sf-count]'); if (cnt) cnt.textContent = ((list.children[start] ? start : 0) + 1) + ' / ' + data.length;
    list.querySelectorAll('[data-sf-add]').forEach((b) => b.addEventListener('click', () => add(b)));
    dlg.classList.add('is-open');
    document.documentElement.classList.add('sf-player-locked');
    syncMute();
    io && io.disconnect();
    io = new IntersectionObserver((es) => es.forEach((e) => {
      const v = e.target.querySelector('video');
      if (e.isIntersecting && e.intersectionRatio > 0.6) {
        // load this one and the next, play this one
        [e.target, e.target.nextElementSibling].forEach(loadSlide);
        v.muted = muted; v.play().catch(() => {});
        const c = dlg.querySelector('[data-sf-count]'); if (c) c.textContent = (Number(e.target.dataset.i) + 1) + ' / ' + items.length;
      } else v.pause();
    }), { root: list, threshold: [0, 0.6, 1] });
    list.querySelectorAll('.sf-player__slide').forEach((s) => io.observe(s));
    const first = list.children[start] || list.children[0];
    list.scrollTop = first.offsetTop;
    dlg.querySelector('[data-sf-close]').focus();
  }
  function close() {
    if (!dlg) return;
    io && io.disconnect();
    list.querySelectorAll('video').forEach((v) => { v.pause(); v.removeAttribute('src'); v.load(); });
    dlg.classList.remove('is-open');
    document.documentElement.classList.remove('sf-player-locked');
    lastFocus && lastFocus.focus && lastFocus.focus();
  }

  function init() {
    document.querySelectorAll('[data-sf-reels]').forEach((root) => {
      if (root.dataset.sfReelsWired) return; root.dataset.sfReelsWired = '1';
      let data = [];
      try { data = JSON.parse(root.querySelector('[data-sf-reels-data]').textContent); } catch (e) { return; }
      root.querySelectorAll('[data-sf-reel-open]').forEach((b) => b.addEventListener('click', () => open(data, Number(b.dataset.sfReelOpen))));
      wireCards(root); wireArrows(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
